import { connect } from 'react-redux';
import Generator from './index';

const mapStateToProps = (state) => {
	return {
		user: state.auth.user,
	};
};

export default connect(mapStateToProps)(Generator);
